module.exports = __webpack_public_path__ + "static/media/cash-bags.7942dc65.svg";